const TYPES_LIST_REQUEST = 'TYPES_LIST_REQUEST';
const TYPES_LIST_SUCCESS = 'TYPES_LIST_SUCCESS';
const TYPES_LIST_FAILURE = 'TYPES_LIST_FAILURE';


const types = {
    TYPES_LIST_FAILURE,
    TYPES_LIST_REQUEST,
    TYPES_LIST_SUCCESS,

}

export default types;